/** Clave i18n estable para ítems de menú lateral (tabla menu, campo action). */
export function getMenuLabelKey(menu: { action?: number | string | null; id?: number | null } | null | undefined): string | null {
  if (!menu) {
    return null;
  }
  if (menu.action != null && menu.action !== '') {
    const action = Number(menu.action);
    if (!Number.isNaN(action) && action >= 0) {
      return `MENU.${action}`;
    }
  }
  if (menu.id != null) {
    return `MENU.ID.${menu.id}`;
  }
  return null;
}
